import React from "react";
import PropTypes from "prop-types";
import Swatch from "./Swatch";
import { colorScales, labels } from "../../constants/colors";

function ColorScaleOption({
  isHighlighted,
  isSelected,
  SelectionRenderer,
  option,
  className,
}) {
  return (
    <div className={className}>
      <div
        className={`${
          isHighlighted ? "bg-3 color-1" : "bg-1 color-3"
        } tw-flex tw-items-center tw-text-2xs color-2 tw-cursor-pointer`}
      >
        <SelectionRenderer isSelected={isSelected} />
        <div className="tw-truncate tw-w-20">{labels[option]}</div>
        <div className="">
          <Swatch colorScale={colorScales[option]} space={8} />
        </div>
        <div className="tw-w-5" />
      </div>
    </div>
  );
}

ColorScaleOption.propTypes = {
  className: PropTypes.string,
  option: PropTypes.string.isRequired,
  isHighlighted: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  SelectionRenderer: PropTypes.func,
};

ColorScaleOption.defaultProps = {
  SelectionRenderer: () => null,
  className: "",
};

export default ColorScaleOption;
